//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { venues_list, playingField_detail, playingField_insert, playingField_update } from '@/apis/stadium'
import { sportType_list } from '@/apis/config'

export default {
    data() {
        //表單校驗
        const rules = {
            fieldName: [{ required: true, message: '請輸入場地名稱！' }],
            sportTypeCode: [{ required: true, message: '請選擇運動類型！' }],
            venueCode: [{ required: true, message: '請選擇所屬場館！' }],
            status: [{ required: true, message: '請選擇場館狀態！' }],
        };

        const form = {
            fieldName: undefined,
            sportTypeCode: undefined,
            venueCode: undefined,
            status: undefined,
            sortOrder: 0
        };

        return {
            id: '',
            form,
            rules,
            spinning: false,
            config: {
                //運動類型
                motions: [],
                gymnasiums: [],
            },
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.onPageConfig();
        if (this.id > 0)
            await this.onPageLoad();
    },
    methods: {
        async onPageConfig() {
            try {
                //加載運動類型
                const res = await sportType_list({ typeCode: '', name: '', pageSize: 99, pageNumber: 1 });
                this.config.motions = res.data.records;
                //加載所屬場館
                const gymnasiumsRes = await venues_list({ venueCode: '', venueName: '', sportTypeCode: '', status: '', areaCode: '', pageSize: 999, pageNumber: 1 });
                this.config.gymnasiums = gymnasiumsRes.data.records;
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad() {
            try {
                const res = await playingField_detail(this.id);
                if (res.code == 0) {
                    const item = res.data || {};
                    const form = { ...this.form };
                    form.id = this.id;
                    form.fieldName = item.fieldName;
                    form.venueCode = item.venueCode;
                    form.sportTypeCode = item.sportTypeCode;
                    form.status = item.status + '';
                    this.form = form;
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async handleFormValidate(e) {
            e.preventDefault();


            try {
                this.spinning = true;

                const submitForm = {
                    ...this.form,
                };

                if (this.id) {
                    //update
                    submitForm.id = this.id;
                    const res = await playingField_update(submitForm);
                    if (res.code == 0) {
                        this.$message.success('編輯完成');
                        this.$router.push('/stadium');
                    }
                } else {
                    //insert
                    const res = await playingField_insert(submitForm);
                    if (res.code == 0) {
                        this.$message.success('提交完成');
                        this.$router.push('/stadium');
                    }
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
